var exports = {
  "iE": "xaf9ae18d--d55f11--wrapper",
  "_R": "xaf9ae18d--d55f11--close-button",
  "$e": "xaf9ae18d--d55f11--warning",
  "VS": "xaf9ae18d--d55f11--years",
  "Zu": "xaf9ae18d--d55f11--fixed",
};

module.exports = exports;
